export { getRUMConfig } from './getRUMConfig';
